import { HTTP } from "./http-common";

const bookingAPI = {
  searchBooking(bookingCode, lastName) {
    return HTTP.get("/booking/search", {
      params: {
        bookingCode,
        lastName,
      },
    })
      .then((response) => response.data)
      .catch((error) => {
        console.log("[/booking/search] error:", error);

        let message =
          "[CB1] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.";

        if (error.response && error.response.data) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log("data:", error.response.data);
          console.log("status:", error.response.status);
          // console.log(error.response.headers)

          if (error.response.status !== 500) {
            message = error.response.data.message || error.response.data.error;
          }

          throw {
            ...error,
            message: message,
          };
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
        console.log(error.config);
        throw error;
      });
  },

  updateBooking(booking) {
    console.log("[API updateBooking] booking:", booking);

    return HTTP.patch(`/booking/${booking.bookingID}`, {
      booking,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CB2] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },

  updateCabinConfiguration(cabinConfigurations) {
    console.log(
      "[API updateCabinConfiguration] cabinConfigurations:",
      cabinConfigurations,
    );

    return HTTP.put(`/cabin-configuration`, { cabinConfigurations })
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CB3] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },

  confirmBooking(booking) {
    console.log("[API confirmBooking] booking:", booking);

    return HTTP.post(`/booking/confirm`, { booking })
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CB4] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },

  sendCruiseTicketEmail(cabinConfigurations, email, name) {
    console.log(
      "[API sendCruiseTicketEmail] cabinConfigurations, email, name:",
      cabinConfigurations,
      email,
      name,
    );

    return HTTP.post(`/booking/email-ticket`, {
      cabinConfigurations,
      email,
      name,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw {
          ...error,
          message:
            (error.response &&
              error.response.data &&
              (error.response.data.message || error.response.data.error)) ||
            "[CB5] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.",
        };
      });
  },
};

export default bookingAPI;



// WEBPACK FOOTER //
// ./src/api/booking.js